export interface FiscalResultLabelJson {
  id: number;
  label: string;
  type: string;
  comment_needed: boolean;
  code: string;
  section?: string;
  line_type?: 'line' | 'total';
  is_automated_sci_account?: boolean;
}

export class FiscalResultLabel {
  constructor(
    public id: number,
    public label: string,
    public type: string,
    public commentNeeded: boolean,
    public code: string,
    public section?: string,
    public lineType?: 'line' | 'total',
    public isAutomatedSciAccount?: boolean
  ) {}

  static fromJson(json: Partial<FiscalResultLabelJson>): FiscalResultLabel {
    return new FiscalResultLabel(
      json.id,
      json.label,
      json.type,
      json.comment_needed,
      json.code,
      json.section,
      json.line_type,
      json.is_automated_sci_account
    );
  }
}
